<template>
  <Button
    class="toast-button toast-button--bottom"
    :class="{
      'toast-button--pulsing': pulsing,
    }"
    type="primary"
    :disabled="loading"
    :loading="loading"
    @click="restore()"
  >
    <i class="button__icon iconoir-undo"></i>
    {{
      $t('restoreToast.restore', {
        type: $t('trashType.' + toast.data.trash_item_type),
      })
    }}</Button
  >
</template>

<script>
import Button from '@baserow/modules/core/components/Button'
import TrashService from '@baserow/modules/core/services/trash'
import { notifyIf } from '@baserow/modules/core/utils/error'
import {
  TOAST_AUTO_DISMISS_MS,
  TOAST_PULSE_MS,
} from '@baserow/modules/core/utils/toastConstants'

export default {
  name: 'RestoreToast',
  components: {
    Button,
  },
  props: {
    toast: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      pulsing: true,
    }
  },
  mounted() {
    // Both handles are kept so the timers cannot fire on an unmounted
    // component -- `restore()` closes the toast early, which previously left
    // two pending callbacks behind.
    this.pulseTimeout = setTimeout(() => {
      this.pulseTimeout = null
      this.pulsing = false
    }, TOAST_PULSE_MS)
    this.closeTimeout = setTimeout(() => {
      this.closeTimeout = null
      this.close()
    }, TOAST_AUTO_DISMISS_MS)
  },
  beforeUnmount() {
    clearTimeout(this.pulseTimeout)
    clearTimeout(this.closeTimeout)
    this.pulseTimeout = null
    this.closeTimeout = null
  },
  methods: {
    close() {
      this.$store.dispatch('toast/remove', this.toast)
    },
    async restore() {
      this.loading = true
      this.pulsing = false
      try {
        await TrashService(this.$client).restore(this.toast.data)
      } catch (error) {
        notifyIf(error, 'trash')
      }
      this.close()
      this.loading = false
    },
  },
}
</script>
